var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"md":"7"}},[_c('BarChart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"height":250}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }